import z from "zod";

/**
 * FornecedorAvaliacaoEditarSchema
 */

export const FornecedorAvaliacaoEditarSchema = z.object({
  avaliadoPor: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
  data: z.coerce.date({ required_error: 'Este campo deve ser preenchido!' }),
  observacao: z.string(),
  items: z.array(z.object({
    idItemAvaliacaoFornecedor: z.number(),
    descricao: z.string().nullable().default(null),
    nota: z.number().nullable().default(null),
  })).default([]),
});

/**
 * FornecedorAvaliacaoEditarForm
 */

export type FornecedorAvaliacaoEditarForm = z.infer<typeof FornecedorAvaliacaoEditarSchema>;